import { action, thunk } from 'easy-peasy';
var jsonDataStore = {
    btnConfig: {},
    mainConfig: {},
    bottomToolConfig: {},
    bottomConfig: {},
    uiAssets: { drawerIconOpen: '', drawerIconClosed: '' },
    rightConfig: {},
    decksByGrade: [],
    setBtnConfig: action(function (state, payload) {
        state.btnConfig = payload;
    }),
    setMainConfig: action(function (state, payload) {
        state.mainConfig = payload;
    }),
    setBottomToolConfig: action(function (state, payload) {
        state.bottomToolConfig = payload;
    }),
    setBottomConfig: action(function (state, payload) {
        state.bottomConfig = payload;
    }),
    setUiAssets: action(function (state, payload) {
        state.uiAssets = payload;
    }),
    setRightConfig: action(function (state, payload) {
        state.rightConfig = payload;
    }),
    setDecksByGrade: action(function (state, payload) {
        state.decksByGrade = payload;
    }),
    fetchJsonData: thunk(function (actions, _payload) {
        return new Promise(function (resolve, reject) {
            fetch('./assets/data/btnData.json')
                .then(function (r) { return r.json(); })
                .then(function (btnData) {
                actions.setBtnConfig(btnData.btnConfig);
                actions.setMainConfig(btnData.mainConfig);
                actions.setBottomToolConfig(btnData.bottomToolConfig);
                actions.setBottomConfig(btnData.bottomConfig || {});
                actions.setUiAssets(btnData.uiAssets || { drawerIconOpen: '', drawerIconClosed: '' });
                actions.setRightConfig(btnData.rightConfig || {});
                resolve(null);
            })
                .catch(function (err) {
                console.log(err);
                reject();
            });
        });
    }),
    fetchCardDecks: thunk(function (actions, isLoggedIn) {
        var file = isLoggedIn
            ? './assets/data/cardDecksConfig.json'
            : './assets/data/cardDecksConfigGuest.json';
        return fetch(file)
            .then(function (r) { return r.json(); })
            .then(function (data) {
            actions.setDecksByGrade(data.decksByGrade || []);
        })
            .catch(function (err) {
            console.log(err);
        });
    }),
};
export default jsonDataStore;
